import { FileText, Download } from "lucide-react";
import Button from "./Button";

export default function FileAttachment({ att }) {
  if (!att?.payload?.url) return null;
  
  const fileName = att.title;
  const fileType = att.payload.fileType 

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = att.payload.url;
    link.download = fileName;
    link.setAttribute("download", fileName); 
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="mt-3 mb-3 flex items-center justify-between bg-gray-50 p-3 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors duration-200">
      
      {/* Card clickable mở file */}
      <a
        href={att.payload.url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center space-x-3 flex-1"
      >
        <FileText className="h-5 w-5 text-blue-500" />
        <div>
          <p className="text-sm font-medium text-gray-800">{fileName}</p>
          <p className="text-xs text-gray-500">
            {fileType} 
            {/* • {fileSize} */}
          </p>
        </div>
      </a>

      {/* Nút tải file */}
      <Button
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0 text-gray-500 hover:text-gray-700"
        onClick={handleDownload}
      >
        <Download className="h-4 w-4" />
      </Button>
    </div>
  );
}
